<!--清关报表设置-->
<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px" size="mini">
      <div class="row-wrap" style="padding:0px 30px;">
        <span style="font-size: 12px">选择模板：</span>
        <el-select v-model="curqingguanNid" size="mini" style="margin-bottom: 5px;margin-right: 5px"
                   @change="qingguanChange">
          <el-option v-for="d in form.qgs" :key="d.id" :label="d.xlabel" :value="d.nid">
          </el-option>
        </el-select>
        <el-button size="mini" v-if="!qgDefault" @click="setQingguanDefault">设为默认模板</el-button>
        <el-button size="mini" @click="addQingguan">添加新模板</el-button>
        <el-button size="mini" @click="editQingguan">修改模板名称</el-button>
        <el-button size="mini" @click="addMoreField">添加更多字段</el-button>
        <el-button size="mini" @click="addCustomerColumn">添加自定义字段</el-button>
        <el-table :data="curqingguan" ref="qingguanRef" border style="width: 100%" size="mini" highlight-current-row
                  stripe>
          <el-table-column label="清关资料">
            <el-table-column type="selection" width="80"></el-table-column>
            <el-table-column type="index" min-width="100" :label="msg('序号')"></el-table-column>
            <!--                            <el-table-column prop="key"  min-width="120" :label="msg('字段KEY')" show-overflow-tooltip></el-table-column>-->
            <el-table-column prop="name" min-width="120" :label="msg('字段NAME')"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="name1" min-width="120" :label="msg('字段显示名')" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-input v-model="scope.row.name1" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="value" min-width="120" :label="msg('固定值')" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-input v-model="scope.row.value" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="排序" min-width="100">
              <template slot-scope="scope">
                <el-link @click="handleMoveUp(curqingguan, scope.$index)" icon="el-icon-top"></el-link>
                <el-link @click="handleMoveDown(curqingguan, scope.$index)" style="margin-left:5px;"
                         icon="el-icon-bottom"></el-link>
                <el-link @click="handleRemove(curqingguan,scope.$index)" style="margin-left:5px;"
                         icon="el-icon-delete"></el-link>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
        <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{
            msg('确定')
          }}</span>
        </el-button>
      </div>
    </el-form>
    <el-dialog :title="msg('选择字段')" :visible.sync="stockFieldSelectVisiable" :close-on-click-modal="false">
      <StockFieldSelect @doneselect="doneselect"/>
    </el-dialog>
  </div>
</template>

<script>
import StockFieldSelect from "@/views/sys/StockFieldSelect.vue";
export default {
  name: "UserSettingReportQingguan",
  components:{
    StockFieldSelect: StockFieldSelect,
  },
  data() {
    return {
      xgroup: 'QINGGUAN_REPORT',  //电子秤group
      form: {
        qgs: [],
      },
      curqingguanNid: null,
      curqingguanIndex: 0,
      qingguans: [
        {
          key: 'index',
          name: '編號',
          name1: '編號',
          value: '',
          show: true,
        },
        {
          key: 't.exp_pkg_code',
          name: '袋號',
          name1: '袋號',
          value: '',
          show: true,
        },
        {
          key: 't.code',
          name: '提單號碼',
          name1: '提單號碼',
          value: '',
          show: true,
        },
        {
          key: 't.exp_page_code',
          name: '面单码',
          name1: '面单码',
          value: '',
          show: true,
        },
        {
          key: 't.exp_code',
          name: '查询码',
          name1: '查询码',
          value: '',
          show: true,
        },
        {
          key: '1 as jianshu',
          name: '件數',
          name1: '件數',
          value: '',
          show: true,
        },
        {
          key: 't.weight_exp',
          name: '提單重量(KG)',
          name1: '提單重量(KG)',
          value: '',
          show: true,
        },
        {
          key: 't.product_name',
          name: '品名',
          name1: '品名',
          value: '',
          show: true,
        },
        {
          key: 't.order_qty',
          name: '數量',
          name1: '數量',
          value: '',
          show: true,
        },
        {
          key: 'null as pce',
          name: '單位',
          name1: '單位',
          value: '',
          show: true,
        },
        {
          key: 'null as cn',
          name: '產地',
          name1: '產地',
          value: '',
          show: true,
        },
        {
          key: 'null as twd',
          name: '單價(TWD)',
          name1: '單價(TWD)',
          value: '',
          show: true,
        },
        {
          key: 'null as jijian',
          name: '寄件公司',
          name1: '寄件公司',
          value: '',
          show: true,
        },
        {
          key: 'null as jijianren',
          name: '寄件人',
          name1: '寄件人',
          value: '',
          show: true,
        },
        {
          key: 'null as shoujiantb',
          name: '收件統編',
          name1: '收件統編',
          value: '',
          show: true,
        },
        {
          key: 't.receiver',
          name: '收件人',
          name1: '收件人',
          value: '',
          show: true,
        },
        {
          key: 't.receiver_tel',
          name: '收件公司電話',
          name1: '收件公司電話',
          value: '',
          show: true,
        },
        {
          key: 't.receiver_addr',
          name: '收件地址',
          name1: '收件地址',
          value: '',
          show: true,
        },
        {
          key: 'null as shenfenz',
          name: '統編/身份證號碼',
          name1: '統編/身份證號碼',
          value: '',
          show: true,
        },
        {
          key: 'null as leibie',
          name: '報單類別',
          name1: '報單類別',
          value: '',
          show: true,
        },
        {
          key: 'null as shuize',
          name: '稅則',
          name1: '稅則',
          value: '',
          show: true,
        },
        {
          key: 'null as nashui',
          name: '納稅辦法',
          name1: '納稅辦法',
          value: '',
          show: true,
        },
        {
          key: 't.exp_company',
          name: '派件公司',
          name1: '派件公司',
          value: '',
          show: true,
        },
        {
          key: 't.weight_pkg',
          name: '袋重',
          name1: '袋重',
          value: '',
          show: true,
        },
        {
          key: 't.order_origin',
          name: '订单来源',
          name1: '订单来源',
          value: '',
          show: true,
        },
        {
          key: 't.exp_out_type',
          name: '出货方式',
          name1: '出货方式',
          value: '',
          show: true,
        },
        {
          key: 't.exp_batch',
          name: '批次',
          name1: '批次',
          value: '',
          show: true,
        },
        {
          key: 't3.fullname as ownerName',
          name: '归属人',
          name1: '归属人',
          value: '',
          show: true,
        },
        {
          key: 't.order_bag_code',
          name: '包号',
          name1: '包号',
          value: '',
          show: true,
        },
        {
          key: 't.weight_cust_pkg',
          name: '包重',
          name1: '包重',
          value: '',
          show: true,
        },
        {
          key: 'null as product_volume_str',
          name: '体积',
          name1: '体积',
          value: '',
          show: true,
        },
        {
          key: 'null as remark1',
          name: '',
          name1: '',
          value: '',
          show: true,
        },
        {
          key: 'null as remark2',
          name: '',
          name1: '',
          value: '',
          show: true,
        },
      ],
      curqingguan: [],
      qgDefault: true,
      stockFieldSelectVisiable: false, //选择清关导出字段
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      _this.form.qgs = [];

      let qingguanReports = data;//清关报表设置

      //清关报表
      qingguanReports = qingguanReports.filter(a => a.xvalue);
      if (qingguanReports.length > 0) {
        var curIndex = 0;
        qingguanReports.forEach((a, index) => {
          let qg = {
            id: a.id ? a.id : null,
            xkey: a.xkey,
            owner: a.owner ? a.owner : null,
            xgroup: _this.xgroup,
            xvalue: a.xvalue,
            xtype: 1,
            xlabel: a.xlabel,
            nid: a.id ? a.id : null,
            remark: a.remark ? a.remark : ''
          }
          if (a.remark == 'default') {
            curIndex = index;
          }
          _this.form.qgs.push(qg);
        })
        _this.curqingguanIndex = curIndex;
        _this.curqingguan = JSON.parse(_this.form.qgs[curIndex].xvalue);
        _this.curqingguanNid = _this.form.qgs[curIndex].nid;
        _this.$nextTick(() => {
          _this.curqingguan.forEach(e => {
            if (e.show) {
              _this.$refs.qingguanRef.toggleRowSelection(e, true);
            }
          })
        })
      } else {
        // var nid = Date.now()
        // _this.form.qgs.push({
        //     id: null,
        //     xkey: _this.xgroup + nid,
        //     owner: null,
        //     xgroup: _this.xgroup,
        //     xvalue: _this.qingguans,
        //     xtype:0,
        //     xlabel:'默认模板',
        //     nid: Date.now(),
        //     remark:'default'
        // })
        // _this.curqingguan = JSON.parse(_this.form.qgs[0].xvalue);
        // _this.curqingguanNid = _this.form.qgs[0].nid;
        // if(this.hasPermission('stock:downloadQingguan')){
        //   _this.$nextTick(() => {
        //     _this.curqingguan.forEach(e => {
        //       _this.$refs.qingguanRef.toggleRowSelection(e, true);
        //     })
        //   });
        // }
      }
    },
    qingguanChange(nid) {
      var index = -1;
      for (var i = 0; i < this.form.qgs.length; i++) {
        if (this.form.qgs[i].nid == nid) {
          index = i;
          break;
        }
      }
      if (index == -1) {
        return;
      }
      this.calcQgShow();
      var oldQg = this.form.qgs[this.curqingguanIndex];
      oldQg.xvalue = JSON.stringify(this.curqingguan);

      var newQg = this.form.qgs[index];
      this.qgDefault = (newQg.remark == 'default')
      this.curqingguan = JSON.parse(newQg.xvalue);
      this.curqingguanIndex = index;

      var _this = this;
      this.$nextTick(() => {
        _this.curqingguan.forEach(e => {
          if (e.show) {
            _this.$refs.qingguanRef.toggleRowSelection(e, true);
          }
        })
      })
    },
    addMoreField() {
      this.stockFieldSelectVisiable = true;
    },
    doneselect(list) {
      var _this = this;
      this.stockFieldSelectVisiable = false;
      if (list && list.length > 0) {
        var count = 0;
        list.forEach(a => {
          var exist = this.curqingguan.some(c => c.key == a.key);
          if (!exist) {
            a.show = true;
            this.curqingguan.push(a);
            count++;
          }
        })
        if (count++) {
          this.$nextTick(() => {
            _this.curqingguan.forEach(e => {
              if (e.show) {
                _this.$refs.qingguanRef.toggleRowSelection(e, true);
              }
            })
          })
        }
      }
    },
    addQingguan() {
      var _this = this;
      var nid = Date.now();
      var remark = (_this.form.qgs.length == 0 ? 'default' : '')
      var qg = {
        id: null,
        xkey: _this.xgroup + nid,
        owner: null,
        xgroup: _this.xgroup,
        xvalue: JSON.stringify(this.qingguans),
        xtype: 0,
        xlabel: '模板' + (_this.form.qgs.length + 1),
        nid: nid,
        remark: remark
      }
      _this.form.qgs.push(qg)
      _this.curqingguan = _this.qingguans;
      _this.curqingguanNid = nid;
      _this.curqingguanIndex = _this.form.qgs.length - 1;
      _this.$nextTick(() => {
        _this.curqingguan.forEach(e => {
          _this.$refs.qingguanRef.toggleRowSelection(e, true);
        })
      });
      _this.qgDefault = (remark == 'default');
    },
    editQingguan() {
      this.$prompt(' ', '输入模板名称：', {inputValue: `${this.form.qgs[this.curqingguanIndex].xlabel}`}).then(({
                                                                                                                 value,
                                                                                                                 action
                                                                                                               }) => {
        if (!value) {
          return false;
        }
        this.form.qgs[this.curqingguanIndex].xlabel = value
      })
    },
    addCustomerColumn() {
      var _this = this;
      var id = Date.now().toString();
      var tmp = {
        key: 'null as a' + id,
        name: '',
        name1: '',
        value: '',
        show: true,
      };
      this.curqingguan.push(tmp);
      this.$nextTick(() => {
        _this.$refs.qingguanRef.toggleRowSelection(tmp, true);
      })
    },
    setQingguanDefault() {
      this.form.qgs.forEach(a => {
        if (this.curqingguanNid == a.nid) {
          a.remark = 'default'
        } else {
          a.remark = '';
        }
      })
      this.qgDefault = true;
      // this.form.qgs.splice(0, 1, ...this.form.qgs.splice(this.curqingguanIndex, 1, this.form.qgs[0]));
      // this.curqingguanIndex = 0;
      // this.curqingguanNid = this.form.qgs[0].nid;
    },
    calcQgShow() { //计算清关显示字段的show字段
      var list = this.$refs.qingguanRef.selection;
      this.curqingguan.forEach(a => {
        a.show = false;
      })
      list.forEach(a => {
        a.show = true;
      })
    },
    handleMoveUp(datas, index){
      if(index == 0){
        return;
      }
      let row = datas[index];
      let prevRow = datas[index-1];
      //触发数组变动
      datas.splice(index, 1, prevRow);
      datas.splice(index - 1, 1, row);
    },
    handleMoveDown(datas, index){
      if(index >= datas.length-1){
        return;
      }
      let row = datas[index];
      let lastRow = datas[index+1];
      datas.splice(index, 1, lastRow);
      datas.splice(index+1, 1, row);
    },
    handleRemove(datas,index){
      datas.splice(index, 1)
    },
    update() {
      let datas = [];
      //构建清关报表
      if (this.hasPermission('stock:downloadQingguan')) {
        if (this.form.qgs.length > 0) {
          this.calcQgShow();
          var oldQg = this.form.qgs[this.curqingguanIndex];
          oldQg.xvalue = JSON.stringify(this.curqingguan);

          this.form.qgs.forEach(qg => {
            datas.push({
              id: qg.id ? qg.id : null,
              xkey: qg.xkey,
              owner: qg.owner ? qg.owner : null,
              xgroup: this.xgroup,
              xvalue: qg.xvalue,
              xlabel: qg.xlabel,
              xtype: 1,
              remark: qg.remark
            });
          })
        }

        var _this = this;
        _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
          _this.$message(result.msg)
        });
      }
    }
  }
}
</script>

<style scoped>

</style>